import './_body-view-height'
import {gsap} from 'gsap'

const confettiTrigger = $('#confetti-trigger');

confettiTrigger.click(function () {


    const tl = gsap.timeline({
        repeat: 1, yoyo: true,
    }, {});


    tl.to("#confetti-emoji", {opacity: 1, scaleX: 1.8, scaleY: 1.8, rotate: 7, ease: "none"})

    tl.to("#confetti-emoji", {opacity: 1, scaleX: 1.8, scaleY: 1.8, rotate: -7, ease: "none"})

    tl.to("#confetti-emoji", {opacity: 1, scaleX: 1.8, scaleY: 1.8, rotate: 7, ease: "none"})
    // jsConfetti.addConfetti({
    //     confettiColors: [
    //         '#0D0C91', '#FC47DF', '#02B9E1', '#ff85a1', '#FFE600', '#FFE600',
    //     ],
    // })
})


import './_menu.js';
import './_menu-scroll.js';
import './_intersection-observer.js';
import './_scroll-to.js';
import './_offices.js'; 
import './_block-support.js';
import './_tab-menu.js';

//skip header
let skipHeader = document.querySelector('a.visually-hidden.skip-to-main');
if(skipHeader != undefined) {
    skipHeader.addEventListener('focusin', function (e) {
        this.classList.add('focused');  
    });
    skipHeader.addEventListener('focusout', function (e) {
        this.classList.remove('focused');  
    });
}
